<template>
  <div class="finder">
    <div id="quickfind">
      <h2>Quick find</h2>

      <QuickfindGroup
        v-for="(item, index) in lists"
        :key="index"
        :data="item"
        :preshow="index === 0" />
    </div>

    <router-link to="/product-finder" id="btn-finder">
      <span class="icon">
        <i class="far fa-laptop"></i>
      </span>
      <span class="text">Product Finder</span>
      <span class="arrow">
        <i class="far fa-arrow-circle-right"></i>
      </span>
    </router-link>
  </div>
</template>

<script>
import QuickfindGroup from '@/components/quickfind/QuickfindGroup.vue';

export default {
  name: 'QuickFind',

  components: {
    QuickfindGroup,
  },

  computed: {
    brands() {
      const specs = this.$store.state.specifications.items;
      const { options } = specs.find((item) => item.slug === 'brand');
      return options;
    },

    lists() {
      const types = {
        title: 'Type',
        icon: 'fa-border-all',
        options: [
          {
            title: 'Mainstream',
            link: '/products/mainstream',
            img: '',
          },
          {
            title: 'Premium',
            link: '/products/premium',
            img: '',
          },
          {
            title: 'Gaming',
            link: '/products/gaming',
            img: '',
          },
        ],
      };

      const processor = {
        title: 'Processor',
        icon: 'fa-microchip',
        options: [
          {
            title: 'Intel',
            link: '/processor/intel',
            img: '',
          },
          {
            title: 'AMD',
            link: '/processor/amd',
            img: '',
          },
        ],
      };

      const prices = {
        title: 'Price',
        icon: 'fa-usd-square',
        options: [
          {
            title: '< 5jt',
            link: '/price/max-5jt',
            img: '',
          },
          {
            title: '5jt - 10jt',
            link: '/price/5jt-sd-10jt',
            img: '',
          },
          {
            title: '> 10jt',
            link: '/price/min-10jt',
            img: '',
          },
        ],
      };

      const brands = {
        title: 'Brand',
        icon: 'fa-tags',
        options: this.remapBrands(),
      };

      return [
        types,
        processor,
        prices,
        brands,
      ];
    },
  },

  methods: {
    remapBrands() {
      return this.brands.map((item) => ({
        title: item.name,
        link: `/brand/${item.name.toLowerCase()}`,
        img: '',
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
  #quickfind {
    padding: 1.5rem;
    background-color: rgba($white, 0.1);

    .light & {
      background-color: rgba($base-color, 0.05);
      color: $base-color;
    }

    > h2 {
      font-size: 1.25rem;
      margin-bottom: 1rem;
    }
  }

  #btn-finder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    width: 100%;
    background-color: $color-primary;
    border-radius: 0;
    border: none;
    color: $white;
    text-decoration: none;

    .light & {
      color: $base-color;
    }

    .icon {
      height: 3rem;
      width: 4rem;
      line-height: 3rem;
      margin-right: 1rem;
      background-color: darken($color-primary, 10%);
      vertical-align: middle;
      text-align: center;
    }

    .text {
      width: 100%;
      font-weight: 800;
      text-align: left;
      text-transform: uppercase;
    }

    .arrow {
      width: 4rem;
      text-align: center;

      svg {
        height: 1.5rem;
        width: 1.5rem;
      }
    }
  }
</style>
